export { default as WxButton } from './wxButton';
export { default as WxClock } from './wxClock';
export { default as WxDrawer } from './wxDrawer';
export { default as WxFabButton } from './wxFabButton';
export { default as WxFooter } from './wxFooter';
export { default as WxHeader } from './wxHeader';
export { default as WxConfirm } from './wxConfirm';
